export class TrainingSetting {
    constructor(id, name, value) {
        this.id = id;
        this.name = name;
        this.value = value;
    }
}
